<ion-header class="ion-no-border ion-header-modal-mobile">
  <ion-toolbar>
    <ion-label class="filter-label-container" data-cy="filter-label">
      {{ 'i18n.sellerShowcasePage.filter' | translate }}
      <ion-badge data-cy="filter-qty-badge" class="green-badge" mode="ios">
        {{ selectedFilters?.size ?? 0 }}
      </ion-badge>
    </ion-label>
  </ion-toolbar>
</ion-header>

<ion-content class="ion-content-modal-mobile">
  <app-highlighted-selectable-item
    [label]="'i18n.sellerShowcasePage.brand'"
    [selected]="selectedFilter === filterTypes.brand"
    [index]="0"
    [value]="selectedBrand"
    (clickValueEmitter)="setFilter(filterTypes.brand)"
  ></app-highlighted-selectable-item>
  <app-highlighted-selectable-item
    [label]="'i18n.sellerShowcasePage.promoType'"
    [selected]="selectedFilter === filterTypes.promoType"
    [index]="1"
    [value]="selectedPromoType"
    (clickValueEmitter)="setFilter(filterTypes.promoType)"
  ></app-highlighted-selectable-item>
  <app-highlighted-selectable-item
    [label]="'i18n.sellerShowcasePage.exclusiveBrands'"
    [selected]="selectedFilter === filterTypes.exclusiveBrand"
    [index]="2"
    [value]="selectedExclusiveBrand"
    (clickValueEmitter)="setFilter(filterTypes.exclusiveBrand)"
  ></app-highlighted-selectable-item>
  <app-highlighted-selectable-item
    [label]="'i18n.sellerShowcasePage.productClass'"
    [selected]="selectedFilter === filterTypes.productClass"
    [index]="3"
    [value]="selectedProductClass"
    (clickValueEmitter)="setFilter(filterTypes.productClass)"
  ></app-highlighted-selectable-item>
</ion-content>

<ion-footer class="ion-footer-modal">
  <ion-toolbar>
    <ion-buttons>
      <ion-button
        id="clear-all-modal-btn"
        data-cy="clear-all-filter-modal-button"
        class="usf-outline-green-mobile-modal-button"
        (click)="clearAll()"
      >
        {{ 'i18n.common.clearAll' | translate }}
      </ion-button>
      <ion-button
        id="apply-modal-btn"
        data-cy="apply-filter-modal-button"
        class="usf-fill-green-mobile-modal-button"
        (click)="applyAll()"
      >
        {{ 'i18n.common.apply' | translate }}
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-footer>
